import styled from '@emotion/styled';
import { spacing } from 'theme';

export const OppRequirements = styled.div({
  marginBlock: `${spacing[20]} ${spacing[36]}`,

  '& .oppRequirements__text': {
    marginBottom: spacing[8],
  },
});

export const BadgeWrapper = styled.div({
  display: 'flex',
  gap: spacing[8],
  flexWrap: 'wrap',
  paddingTop: spacing[12],
});
